import * as types from '../actions/actionTypes';

let initialState = {
    approvers: {
        loading: false,
        success: true,
        data: []
    },
    userDetails: {
        loading: false,
        success: true,
        data: {}
    },
    userPermissions: {
        loading: false,
        success: true,
        data: []
    },
    updateUser: {
        loading: false,
        success: true,
        message: ''
    },
    updateUserDetail: {
        loading: false,
        success: true
    },
    createUser: {
        loading: false,
        success: true,
        message: ''
    },
    permissionsForRole: {
        loading: false,
        success: true,
        data: []
    }
};

export default function usersReducer(state = initialState, action) {
    switch (action.type) {
        case types.START_GET_APPROVERS:
            return Object.assign({}, state, { approvers: { ...state.approvers, success: true, loading: true } });
        case types.GET_APPROVERS:
            return Object.assign({}, state, { approvers: action.response });

        case types.START_GET_USER_DETAILS:
            return Object.assign({}, state, { userDetails: { ...initialState.userDetails, loading: true } });
        case types.GET_USER_DETAILS:
            return Object.assign({}, state, { userDetails: action.response });

        case types.START_GET_USER_PERMISSIONS:
            return !action.myPermissions ? Object.assign({}, state, { userPermissions: { ...initialState.userPermissions, loading: true } }) : state;
        case types.GET_USER_PERMISSIONS:
            return !action.myPermissions ? Object.assign({}, state, { userPermissions: action.response }) : state;

        case types.CLEAR_USER_DETAILS_AND_PERMISSIONS:
            return Object.assign({}, state, {
                userDetails: initialState.userDetails,
                userPermissions: initialState.userPermissions,
                permissionsForRole: initialState.permissionsForRole
            });

        case types.START_UPDATE_USER:
            return Object.assign({}, state, { updateUser: { ...initialState.updateUser, loading: true } });
        case types.UPDATE_USER:
            return Object.assign({}, state, { updateUser: action.response });

        case types.START_UPDATE_USER_DETAIL:
            return Object.assign({}, state, { updateUserDetail: { ...initialState.updateUserDetail, loading: true } });
        case types.UPDATE_USER_DETAIL:
            return Object.assign({}, state, { updateUserDetail: action.response });

        case types.START_CREATE_USER:
            return Object.assign({}, state, { createUser: { ...initialState.createUser, loading: true } });
        case types.CREATE_USER:
            return Object.assign({}, state, { createUser: action.response });

        case types.START_GET_PERMISSIONS_FOR_ROLE:
            return Object.assign({}, state, { permissionsForRole: { ...initialState.permissionsForRole, loading: true } });
        case types.GET_PERMISSIONS_FOR_ROLE:
            return Object.assign({}, state, { permissionsForRole: action.response });

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/UsersReducer.js